import { Injectable } from '@angular/core';
import { ThemeEntryDto } from '@osos/shared/api';
import { ThemePresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { ThemeParserV1Service } from '../../parsers/theme-parser/theme-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class ThemeFactoryService extends FactoryBase<
  ThemeEntryDto,
  ThemePresenterModel
> {
  constructor(parserFactory: ParserFactory, parser_v1: ThemeParserV1Service) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  override createPresenterModel(model: ThemeEntryDto): ThemePresenterModel {
    const parser = this.getParser(ThemeEntryDto, ThemePresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
  override createDataModel(presenter: ThemePresenterModel): ThemeEntryDto {
    const parser = this.getParser(ThemeEntryDto, ThemePresenterModel);
    const result = parser.getDataModel(presenter);
    return result;
  }
}
